<template>
  <div>
    <div class="calendar-header">
      <div>
        <span class="clickable arrow arrow-left" v-on:tap="changeMonth(-1)">
          <img src="../assets/images/Freccia_sinistra.svg" />
        </span>
        <div class="month-name">{{currMonth}}</div>
        <span class="clickable arrow arrow-rigth" v-on:tap="changeMonth(1)">
          <img src="../assets/images/Freccia_destra_v1.svg" />
        </span>
      </div>
    </div>
    <div class="calendar-body">
      <div class="week">
        <div class="dayNames" v-for="(dayName, index) in daysOfWeek" v-bind:key="index">{{dayName}}</div>
      </div>

      <div class="week" v-for="(week, index) in weeks" v-bind:key="index">
        <div
          v-bind:class="{ today: day.isToday, hasReservations: day.reservations.length, otherMonth: day.otherMonth}"
          class="day"
          v-for="(day, dayIndex) in week"
          v-bind:key="dayIndex"
        >
          <div
            v-on:tap="$emit('selectedDay', {selectedDay:day.date})"
            class="day-number"
          >{{day.dayNumber}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// a.toLocaleString('it-it',{'weekday':'short'})
// import RdsCalendarReservation from './RdsCalendarReservation';

export default {
  name: 'rds-calendar',
  props: ['reservations', 'allUsersReservations'],
  components: {
    // RdsCalendarReservation
  },
  data() {
    return {
      monthFirtDay: getFirstDayOfMonth(new Date()),
      daysOfWeek: DAYS_OF_WEEK
    };
  },
  computed: {
    currMonth() {
      const monthName = this.monthFirtDay.toLocaleString('it-it', {
        month: 'long'
      });
      return monthName[0].toUpperCase() + monthName.slice(1);
    },
    weeks() {
      console.log(this.reservations);
      let today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      const reservations = this.reservations.filter(r => r.date >= today);
      return this.getMonthWeeks(reservations);
    }
  },
  methods: {
    changeMonth(direction) {
      const monthFirtDay = new Date(this.monthFirtDay);
      if (direction === DIRECTIONS.PREV) {
        monthFirtDay.setMonth(monthFirtDay.getMonth() - 1);
      } else {
        monthFirtDay.setMonth(monthFirtDay.getMonth() + 1);
      }
      this.monthFirtDay = new Date(monthFirtDay);
      // Object.assign(this.monthFirtDay, new Date(monthFirtDay));
    },
    getMonthWeeks(reservations) {
      const weeks = [];
      const curDay = new Date(this.monthFirtDay);
      const currMonth = curDay.getMonth();
      let firstWeekday = curDay.getDay() !== 0 ? curDay.getDay() - 1 : 6;
      // console.log(firstWeekday);

      let firstWeek = true;
      while (curDay.getMonth() === currMonth) {
        const weekDays = [];
        if (firstWeek) {
          curDay.setDate(curDay.getDate() - firstWeekday);
          firstWeek = false;
        }
        for (let i = 0; i < 7; i++) {
          const weekday = curDay.getDay() !== 0 ? curDay.getDay() - 1 : 6;
          const day = {};

          if (weekday === i && curDay.getMonth() === currMonth) {
            day.dayNumber = curDay.getDate();
            day.reservations = this.getDayReservations(curDay, reservations);
            day.isToday = this.isToday(curDay);
            day.date = new Date(curDay);
            curDay.setDate(curDay.getDate() + 1);
          } else if (curDay.getMonth() !== currMonth) {
            day.dayNumber = curDay.getDate();
            day.reservations = [];
            curDay.setDate(curDay.getDate() + 1);
            day.otherMonth = true;
          } else {
            day.dayNumber = curDay.getDate();
            day.reservations = [];
            curDay.setDate(curDay.getDate() + 1);
          }
          weekDays.push(day);
        }
        weeks.push(weekDays);
      }
      return weeks;
    },
    getDayReservations(day, reservations) {
      const date = new Date(day);
      date.setHours(0);
      date.setMinutes(0);
      const start = date.getTime();
      date.setDate(date.getDate() + 1);
      const end = date.getTime();
      return reservations.filter(r => r.date > start && r.date < end);
    },
    isToday(day) {
      const today = new Date();
      return (
        day.getDate() === today.getDate() &&
        day.getMonth() === today.getMonth() &&
        day.getFullYear() === today.getFullYear()
      );
    }
  }
};

const DIRECTIONS = {
  PREV: -1,
  NEXT: 1
};
const DAYS_OF_WEEK = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
function getFirstDayOfMonth(date) {
  date = new Date(date);
  date.setDate(1);
  return date;
}
</script>
<style lang="scss" scoped>
$common-radius: 10px;

.calendar-header {
  display: flex;
  border-radius: $common-radius;
  position: relative;

  background-color: #ffffff;
  @include dotted-bottom;
  & > div {
    margin: auto;
    // text-transform: uppercase;
    font-weight: 500;
    display: flex;
    span,
    .month-name {
      padding: 20px;
      margin: auto;
      letter-spacing: 1px;
    }
    .month-name {
      width: 200px;
      text-align: center;
      color: #607d8b;
    }
  }
  .arrow {
    color: #607d8b;
    font-weight: 900;
    font-size: 2em;
    margin: auto;
  }
  .arrow-rigth {
    color: #a31313;
  }
}
.calendar-body {
  border-radius: $common-radius;
  background-color: #ffffff;
  padding: 0px 40px 15px;
}
.calendar-reservation:nth-child(2) {
  margin-top: 23px;
}
.week {
  color: #607d8b;
  display: flex;
  justify-content: space-around;
  .day {
    // overflow: hidden;
    display: flex;
    &.today {
      position: relative;
      top: -11px;
      .day-number {
        width: 18px;
        height: 18px;
        border: $main-sky solid 3px;
        padding: 8px;
        border-radius: 50%;
        margin: 0 2px;
      }
    }
    &.otherMonth {
      .day-number {
        opacity: 0.4;
        text-align: center;
        width: 44px;
        height: 44px;
        margin: auto;
        display: inline-block;
        color: rgba(96, 125, 139, 0.62);
      }
    }
    .day-number {
      text-align: center;
      width: 44px;
      height: 44px;
      margin: auto;
      display: inline-block;
      color: rgba(96, 125, 139, 0.62);
    }
    &.hasReservations {
      position: relative;
      top: -11px;
      &.today {
        .day-number {
          background-color: #ffffff;
          color: rgba(96, 125, 139, 0.62);
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 3px solid $main-blue;
          // position: relative;
          padding: 8px;
          margin: 0 2px;
        }
      }
      .day-number {
        background-color: $main-blue;
        color: #ffffff;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 3px solid $main-blue;
        // position: relative;
        padding: 8px;
        margin: 0 2px;
      }
    }

    &:before {
      content: '';
      float: left;
      padding-top: 100%;
    }
  }
  .dayNames {
    text-align: center;
    padding: 20px 0;
    font-weight: 500;
    min-width: 44px;
    max-width: 44px;
  }
}
</style>
